module.exports = __webpack_public_path__ + "img/vpticon2.8a770a16.png";